import React from 'react';
import { Cpu, Search, Loader2 } from 'lucide-react';

const StatusPill = ({ data, isLoading }) => {
    if (!isLoading) return null;

    // Find the latest action (delegation, tool_call, node transition, or subagent event) in the data array
    const lastAction = data && Array.isArray(data)
        ? [...data].reverse().find(d => d.type === 'delegation' || d.type === 'tool_call' || d.type === 'node' || d.type === 'event')
        : null;

    return (
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-50 text-blue-600 border border-blue-100 text-xs font-medium animate-in fade-in zoom-in duration-300 shadow-sm mb-4">
            {lastAction?.type === 'delegation' ? (
                <Cpu size={12} className="animate-pulse" />
            ) : lastAction?.type === 'tool_call' ? (
                <Search size={12} className="animate-pulse" />
            ) : (
                <Loader2 size={12} className="animate-spin" />
            )}
            <span>
                {lastAction?.type === 'delegation'
                    ? `Consulting ${lastAction.subagent}...`
                    : lastAction?.type === 'tool_call'
                        ? `Running ${lastAction.name.replace(/_/g, ' ')}...`
                        : lastAction?.type === 'event'
                            ? `${lastAction.subagent}: ${lastAction.task || lastAction.name || 'Processing'}`
                            : lastAction?.type === 'node'
                                ? `In ${lastAction.node}...`
                                : "Thinking..."}
            </span>
        </div>
    );
};

export default StatusPill;
